// ============================================================
// Perhitungan usia & IMT anak — dipisah agar mudah diaudit/diubah.
// CATATAN PENTING: Kategori status gizi di sini adalah PERKIRAAN
// KASAR, BUKAN kurva pertumbuhan WHO (IMT/U z-score) yang resmi.
// Selalu sertakan disclaimer di UI.
// ============================================================

// Usia dari tanggal lahir → { years, months, display }
export function calcAge(birthDate, isID = true) {
  if (!birthDate) return { years: null, months: null, display: '-' };
  const b = new Date(birthDate);
  const now = new Date();
  if (isNaN(b.getTime()) || b > now) return { years: null, months: null, display: '-' };

  let years = now.getFullYear() - b.getFullYear();
  let months = now.getMonth() - b.getMonth();
  if (now.getDate() < b.getDate()) months -= 1;
  if (months < 0) { years -= 1; months += 12; }

  const totalMonths = years * 12 + months;
  const display = isID
    ? `${years} tahun${months > 0 ? ` ${months} bulan` : ''}`
    : `${years} year${years !== 1 ? 's' : ''}${months > 0 ? ` ${months} month${months !== 1 ? 's' : ''}` : ''}`;

  return { years, months: totalMonths, display };
}

// IMT = berat(kg) / tinggi(m)^2 → angka (1 desimal) atau null
export function calcIMT(weightKg, heightCm) {
  const w = parseFloat(weightKg);
  const h = parseFloat(heightCm);
  if (!w || !h || h <= 0) return null;
  const m = h / 100;
  return Math.round((w / (m * m)) * 10) / 10;
}

// Kategori status gizi — PERKIRAAN KASAR (bukan WHO z-score).
// dbValue WAJIB salah satu dari nilai yang diizinkan constraint:
// 'Gizi Buruk','Gizi Kurang','Gizi Baik','Berisiko Gizi Lebih','Gizi Lebih','Obesitas'
export function estimateNutrition(imt) {
  if (imt == null) return null;
  if (imt < 13)  return { dbValue: 'Gizi Buruk',          tone: 'danger' };
  if (imt < 14.5) return { dbValue: 'Gizi Kurang',        tone: 'warn' };
  if (imt < 18)  return { dbValue: 'Gizi Baik',           tone: 'good' };
  if (imt < 19.5) return { dbValue: 'Berisiko Gizi Lebih', tone: 'warn' };
  if (imt < 22)  return { dbValue: 'Gizi Lebih',          tone: 'warn' };
  return { dbValue: 'Obesitas', tone: 'danger' };
}

// Label tampilan: tambahkan kata "Perkiraan" hanya untuk UI (tidak disimpan)
export function nutritionLabel(nutrition, isID = true) {
  if (!nutrition) return '-';
  return isID ? `Perkiraan: ${nutrition.dbValue}` : `Estimate: ${nutrition.dbValue}`;
}